package com.patronat.top.client.di

import com.patronat.top.client.location.ClientLocationProvider
import com.patronat.top.client.location.JsClientLocationProvider
import org.koin.dsl.module

actual val clientPlatformModule = module {
    single<ClientLocationProvider> { JsClientLocationProvider() }
}
